<div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header text-center">
          <h4>REPORTE DE PRECIOS DE PRODUCTOS</h4>
          <form
            action=""
            [formGroup]="buscarForm"
            (ngSubmit)="buscarExistencia()"
            class="form-horizontal form-material noprint"
            id="categoryform"
            novalidate
          >
            <button onclick="window.print();return false;">
              <i class="fa fa-print"></i>
            </button>
            <div class="form-row">
              <div class="col">
                <app-form-error-wrapper
                  [control]="buscarForm.controls['producto']"
                  [controlName]="'Producto'"
                >
                  <label for="inputGroupSelect02">Producto</label>
                  <ng-select
                    bindLabel="name"
                    placeholder="Selecionar Producto"
                    [searchable]="true"
                    (change)="getSelectedProduct($event)"
                    formControlName="producto"
                  >
                    <ng-option>
                      Seleccionar todos
                    </ng-option>
                    <ng-option [value]="item" *ngFor="let item of products">
                      {{ item.nombre_producto }}
                    </ng-option>
                  </ng-select>
                </app-form-error-wrapper>
              </div>
              <div class="col-xs-12 col-md-2 mt-4">
                <button
                  class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                  [disabled]="buscarForm.invalid || isLoading"
                >
                  <app-button-loader
                    [isLoading]="isLoading"
                    [label]="'Buscar'"
                  ></app-button-loader>
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="card-body">
          <table
            class="table table-bordered table-condensed table-hover table-responsive-md"
          >
            <thead>
              <tr class="text-center">
                <th>#</th>
                <th class="text-left">Nombre del producto</th>
                <th>Estado</th>
                <th>Fecha</th>
                <th>Cantidad</th>
                <th>Precio</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody *ngFor="let data of existencia.lista_pedidos; let i = index">
              <tr>
                <th scope="row" class="text-right">{{ i + 1 }}</th>
                <td
                
                  class="table-success"
                >
                  {{ data.orden_id }}
                </td>
                <td>
                  {{ data.pedido.estado }}
                </td>
                <td>
                  {{ data.pedido.fecha }}
                </td>
                <td>
                  {{ data.cantidad }}
                </td>
                <td>
                  {{ data.precio }}
                </td>
                <td>
                  {{ data.precio * data.cantidad }}
                </td>
               
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
